module.exports = __webpack_public_path__ + "static/media/empathy_intro_cropped.3f9c5e2e.png";